import React from 'react';
import GameQuery from '../../query/GameQuery';
import Documents from '../../components/Documents';
import { DOCUMENTS } from '../../routes';
import { Route } from 'react-router-dom';

const DocumentsRoute = () => 
	<GameQuery>
		{({ game }) => 
			<Route
				path={DOCUMENTS}
				render={props => <Documents {...props} game={game} />}
			/>
		}
	</GameQuery>
;

export default DocumentsRoute;
